import { EarlyIntersector } from "./EarlyIntersector"

export function setupBlockAnimations() {	
	const fadeIns = Array.from(document.querySelectorAll<HTMLElement>('.animate-entry'))
	if (fadeIns) {
		new EarlyIntersector(fadeIns)
	}
}